export const PRODUCT_INTENT = {
  loyalty: 'Loyalty & Rewards',
  reviews: 'Reviews'
};

export const DEFAULT_INTENT = PRODUCT_INTENT['reviews'];
